import { render, staticRenderFns } from "./interfaceService.vue?vue&type=template&id=27071d07&scoped=true&"
import script from "./interfaceService.vue?vue&type=script&lang=js&"
export * from "./interfaceService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27071d07",
  null
  
)

export default component.exports